<template>
  <vs-popup class="add-price-tiers-item-to-cart-pop-up"
            id="popup"
            :title="`PRICE GUIDE (${price_details.formulation_code}) - ${price_details.type === 'Contract' ? 'This product is under contract' : ''}`"
            @close="onClickClose()"
            :active.sync="open"
            :buttons-hidden="true">
    <vx-card no-shadow>
      <vs-alert v-if="price_details.type === 'Bespoke' && sales_order_gap_with_bespoke && price_details.price && price_details.price.length" active="true" class="h-full mt-2 mb-4" color="warning">
        The bespoke price was created on {{ __dateTimeFormatterToDate(price_details.price[0].updated_at) }}. (More than {{ bespoke_price_check_days }} days)
      </vs-alert>

      <vs-alert title="Attention: Shipping Prices Update!" v-if="Number(price_details.shipping_cost) !== Number(price_details.current_shipping_cost)" active="true" class="h-full mt-2 mb-8" color="danger">
        Please note that the shipping prices have been revised since these {{ price_details.type === 'Bespoke' ? 'bespoke' : 'contract' }} prices were set. The previous shipping cost was £{{ Number(price_details.shipping_cost).toFixed(2) }}, 
        and the new cost is now £{{ Number(price_details.current_shipping_cost).toFixed(2) }}.
      </vs-alert>

      <ValidationObserver ref="form" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onClickAddItemToCart)" autocomplete="off">

          <h5 class="mb-4 mt-2">Price tiers</h5>
          <vs-table stripe :data="price_details.price">

            <template slot="thead">
              <vs-th>MinOQ (KG)</vs-th>
              <vs-th>MaxOQ (KG)</vs-th>
              <vs-th>Price (Excl vat {{ account_currency }}/KG)</vs-th>
            </template>

            <template slot-scope="{data}">
              <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                <vs-td :data="data[indextr].from">
                  {{ data[indextr].from }}
                </vs-td>

                <vs-td :data="data[indextr].to">
                  {{ data[indextr].to }}
                </vs-td>

                <vs-td :data="data[indextr].price">
                  {{ data[indextr].price }}
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>

          <!-- Contract Quantities -->
          <div v-if="price_details.type === 'Contract'" class="vx-row mt-6">
            <div class="vx-col md:w-1/3 w-full mb-3 md:mb-0">
              <vx-card card-border no-shadow class="mb-0">
                <div class="flex items-center">
                  <div class="stat-icon-wrapper bg-primary-light mr-3">
                    <feather-icon icon="FileTextIcon" svgClasses="h-6 w-6 text-primary" />
                  </div>
                  <div>
                    <span class="text-xs font-semibold uppercase tracking-wide opacity-75">Contract Quantity</span>
                    <h4 class="font-bold mt-1 text-primary">{{ price_details.contract_quantity || 0 }} <small class="text-xs font-normal">KG</small></h4>
                  </div>
                </div>
              </vx-card>
            </div>

            <div class="vx-col md:w-1/3 w-full mb-3 md:mb-0">
              <vx-card card-border no-shadow class="mb-0">
                <div class="flex items-center">
                  <div class="stat-icon-wrapper bg-warning-light mr-3">
                    <feather-icon icon="ShoppingCartIcon" svgClasses="h-6 w-6 text-warning" />
                  </div>
                  <div>
                    <span class="text-xs font-semibold uppercase tracking-wide opacity-75">Ordered Contract Quantity</span>
                    <h4 class="font-bold mt-1 text-warning">{{ price_details.contract_quantity_ordered || 0 }} <small class="text-xs font-normal">KG</small></h4>
                  </div>
                </div>
              </vx-card>
            </div>

            <div class="vx-col md:w-1/3 w-full mb-3 md:mb-0">
              <vx-card card-border no-shadow class="mb-0">
                <div class="flex items-center">
                  <div class="stat-icon-wrapper bg-success-light mr-3">
                    <feather-icon icon="CheckCircleIcon" svgClasses="h-6 w-6 text-success" />
                  </div>
                  <div>
                    <span class="text-xs font-semibold uppercase tracking-wide opacity-75">Balance Quantity</span>
                    <h4 class="font-bold mt-1 text-success">{{ price_details.contracted_quantity_balance !== undefined && price_details.contracted_quantity_balance !== null ? price_details.contracted_quantity_balance : 0 }} <small class="text-xs font-normal">KG</small></h4>
                  </div>
                </div>
              </vx-card>
            </div>
          </div>

          <div class="vx-row mt-8">
            <div class="vx-col w-full">
              <h5>Notes</h5>
              {{ price_details.note || 'N/A' }}
            </div>
          </div>

          <div class="vx-row mb-3 mt-8">
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="quantity" name="quantity" :rules="'required|moq:'+min_order_quantity+'|maxoq:'+max_order_quantity" v-slot="{ errors }">
                <small class="label">Quantity needed (KG)</small>
                <vs-input  size="large" v-on:input="onTypeQuantity" v-model="createForm.quantity"  name="quantity" class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather"/>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="price" name="price" rules="required" v-slot="{ errors }">
                <small class="label">Price per KG (Excl vat)</small>
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-warning">
                      <span>{{ account_currency }}</span>
                    </div>
                  </template>
                  <vs-input size="large" readonly v-model="createForm.price"   name="price" class=" required" label=""/>
                </vx-input-group>
              </ValidationProvider>
            </div>
            <div class="vx-col md:w-1/3 w-full md:mb-0">
              <ValidationProvider vid="price" name="price" rules="required" v-slot="{ errors }">
                <small class="label">Total price (Excl vat)</small>
                <vx-input-group class="">
                  <template slot="prepend">
                    <div class="prepend-text bg-warning">
                      <span>{{ account_currency }}</span>
                    </div>
                  </template>
                  <vs-input size="large" readonly v-model="createForm.total"   name="price" class=" required" label=""/>
                </vx-input-group>
              </ValidationProvider>
            </div>
          </div>

          <vs-alert v-if="!createForm.is_price_available && Number(createForm.quantity) > 0" active="true" class="h-full mt-2 mb-4" color="danger">
            warning: no price set for this quantity
          </vs-alert>

          <vs-alert v-if="contractQuantityExceeded" active="true" class="h-full mt-2 mb-4" color="warning">
            The quantity entered ({{ createForm.quantity }} KG) exceeds the remaining contracted quantity balance ({{ price_details.contracted_quantity_balance }} KG).
            <router-link :to="{ path: `/pages/manage-nimble/customers/${customerId}`, query: { tab: 'contract', edit_id: price_details.contract_id } }" target="_blank" class="underline font-semibold">
              Update the contract here.
            </router-link>
          </vs-alert>

          <!-- Save & Reset Button -->
          <div class="flex flex-wrap items-center justify-end mt-8">
            <vs-button button="submit" class="ml-auto mt-2" :disabled="!createForm.is_price_available || contractQuantityExceeded">Save Changes</vs-button>
            <vs-button @click="createForm = {}" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </vs-popup>
</template>

<script>
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'

  import { RepositoryFactory } from "@/repository/RepositoryFactory";
  const SettingsRepository = RepositoryFactory.get('settings');

  import moment from "moment"


  function initialState() {
    return {
      open: false,
      index: null,
      customerId: null,
      createForm: {
        is_price_available: false,
        quantity: null
      },
      price_details: {
        type: '',
        price: []
      },
      is_only_add : false,
      bespoke_price_check_days: ''
    }
  }

export default {
  name: 'CalculateProductPricePopUp',
  data () {
    return initialState()
  },
  props: {
    account_currency  : {
      type: String,
      default: '',
    }
  },
  methods:{
    async openPopup (price_details, index, is_only_add = false, customerId = null) {
      try {
        Object.assign(this.$data, initialState())
        this.$refs.form.reset();
        this.index = index
        this.is_only_add = is_only_add
        this.customerId = customerId
        Object.assign(this.price_details, price_details)
        if(!!this.price_details.contract_price && this.price_details.contract_price.constructor === Array ) {
          this.price_details.price = this.price_details.contract_price
        }
        await this.fetchBespokePriceCheckDays()
        if(!!price_details.quantity && Number(price_details.quantity) > 0) {
          this.createForm.quantity = price_details.quantity
          this.onTypeQuantity()
        }
        this.open = true;
      } catch (error) {

      }
    },
    async fetchBespokePriceCheckDays() {
      try {
        this.bespoke_price_check_days = (await SettingsRepository.getTheItem('bespoke_price_check_days')).data.data.bespoke_price_check_days;
      } catch (e) {
        this.convertAndNotifyError(e)
      }
    },
    async onClickAddItemToCart () {
      if (this.contractQuantityExceeded) return
      this.price_details.unit_price = this.createForm.price
      this.price_details.quantity = this.createForm.quantity
      this.open = false
      this.$emit('changeQtyLayer', { data: this.price_details, index: this.index , is_only_add: this.is_only_add})
      // await this.$parent.onChangeQty(this.price_details, this.index)
    },
    onTypeQuantity() {
      const quantity = Number(this.createForm.quantity)
      this.createForm.is_price_available = false
      if (this.price_details.price && Array.isArray(this.price_details.price)) {
        this.price_details.price.forEach((item, index) => {
          const max = Number(item.to)
          const min = Number(item.from)
          let matches = false
          if (index > 0 && this.price_details.price[index - 1] && Number(this.price_details.price[index - 1].to) === min) {
            matches = quantity > min && quantity <= max
          } else {
            matches = quantity >= min && quantity <= max
          }
          if(matches) {
            this.createForm.price = (Number(item.price)).toFixed(2)
            this.createForm.is_price_available = true
          }
        })
      }
      if(!this.createForm.is_price_available) {
        this.createForm.price = Number(0).toFixed(2)
      }
      this.createForm.total = Number(this.createForm.price *quantity).toFixed(2)
    },
    onClickClose () {
      this.$parent.loadProductCart()
      this.open = false
    },
  },
  computed: {
    min_order_quantity: function () {
      if (!this.price_details || !this.price_details.price || !this.price_details.price.length) return 0
      return Number(this.price_details.price[0].from)
    },
    max_order_quantity: function () {
      if (!this.price_details || !this.price_details.price || !this.price_details.price.length) return 0
      return Number(this.price_details.price[this.price_details.price.length -1].to)
    },
    contractQuantityExceeded: function () {
      if (!this.price_details || this.price_details.type !== 'Contract') return false
      const balance = Number(this.price_details.contracted_quantity_balance)
      const qty = Number(this.createForm.quantity)
      return !isNaN(balance) && qty > 0 && qty > balance
    },
    sales_order_gap_with_bespoke: function () {
      if (!this.price_details || !this.price_details.price || !this.price_details.price.length || !this.price_details.price[0].updated_at) return false
      let bespoke_date = moment(this.price_details.price[0].updated_at)
      let now = moment()
      let gap = now.diff(bespoke_date, 'days')
      return gap > Number(this.bespoke_price_check_days)
    }
  }
  ,
  mixins: [SuccessMessage, ErrorMessages],
}
</script>

<style scoped>
  .add-price-tiers-item-to-cart-pop-up >>> .vs-popup {
    /*min-height: 50% !important;*/
    min-width: 45% !important;
  }

  .stat-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 2.75rem;
    height: 2.75rem;
    border-radius: 8px;
    flex-shrink: 0;
  }

  .bg-primary-light {
    background: rgba(var(--vs-primary), 0.12);
  }

  .bg-warning-light {
    background: rgba(var(--vs-warning), 0.12);
  }

  .bg-success-light {
    background: rgba(var(--vs-success), 0.12);
  }
</style>
